// extracted by mini-css-extract-plugin
export var link = "NewsTableOfContents-module--link--a0069";
export var links = "NewsTableOfContents-module--links--44f99";
export var subLinks = "NewsTableOfContents-module--sub-links--4d9fa";
export var tableOfContents = "NewsTableOfContents-module--table-of-contents--dfee8";